module.exports = __webpack_public_path__ + "img/bgphone.11f3e32a.png";